<template>
    <div class="time-banner" @click="$router.push({ path: '/settings' })" title="Change your display timezone">
        <v-icon x-small class="time-banner-icon">mdi-clock-outline</v-icon>
        <span class="time-banner-now">{{ bannerNow }}</span>
        <span class="time-banner-zone">{{ $tz.display() }}</span>
        <span v-if="bannerCompanyTime" class="time-banner-company">
            Company time {{ bannerCompanyTime }}
        </span>
    </div>
</template>

<script>
// Current time in the user's display timezone, shown above the header. Doubles
// as a reminder of which zone they are reading the whole app in.
//
// Deliberately its own component: the clock ticks every second, and keeping
// that state in DefaultLayout would re-run the render function for a very large
// template once a second. Here only this strip re-renders.
export default {
    name: 'TimeBanner',
    data() {
        return { now: Date.now(), timer: null };
    },
    computed: {
        // Reads `now` (per tick) and $date/$tz (per settings change), so the
        // banner follows both the clock and a timezone switch with no extra wiring.
        bannerNow() {
            return this.$date(this.now).format(`ddd, MMM D, YYYY · ${this.$tz.time}`);
        },
        // Only worth showing when the user is not already on company time.
        bannerCompanyTime() {
            if (this.$tz.display() === this.$tz.baseline) return '';
            return this.$date(this.now).tz(this.$tz.baseline).format(this.$tz.time);
        },
    },
    mounted() {
        this.timer = setInterval(() => { this.now = Date.now(); }, 1000);
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer);
    },
};
</script>

<style scoped>
.time-banner {
    position: sticky;
    top: 0;
    z-index: 6;
    display: flex;
    align-items: center;
    gap: 10px;
    height: 32px;
    padding: 0 24px;
    background: #eef2f7;
    border-bottom: 1px solid #dbe2ea;
    color: #4a5568;
    font-size: 0.75rem;
    line-height: 1;
    cursor: pointer;
    user-select: none;
}

.time-banner:hover {
    background: #e4eaf2;
}

.time-banner-icon {
    color: #718096 !important;
}

.time-banner-now {
    font-weight: 600;
    color: #2d3748;
    /* Tabular figures stop the row twitching as the seconds change. */
    font-variant-numeric: tabular-nums;
}

.time-banner-zone {
    padding: 2px 8px;
    border-radius: 10px;
    background: #dde5ef;
    font-weight: 600;
    letter-spacing: 0.02em;
}

.time-banner-company {
    margin-left: auto;
    font-variant-numeric: tabular-nums;
}

@media (max-width: 600px) {
    .time-banner {
        padding: 0 12px;
        gap: 6px;
    }

    /* The company-time hint is the first thing to go on a narrow screen. */
    .time-banner-company {
        display: none;
    }
}
</style>
